module.exports = __webpack_public_path__ + "919f53df6bedaf9b7936ce3d6f002092.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/news/temp.jpg
// module id = 303
// module chunks = 0